import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { tvFavoritesEntityModel } from '~/entities/tv/favorites'

export const loadGridFavoritesTvChannels = createEvent()

sample({
  clock: loadGridFavoritesTvChannels,
  filter: not(api.tv.getOnlyFavoritesTvChannelsGridFx.pending),
  target: api.tv.getOnlyFavoritesTvChannelsGridFx,
})

export const $isGridFavoritesTvChannelsLoading = combine(
  {
    onlyFavoritesTvChannelsLoading:
      api.tv.getOnlyFavoritesTvChannelsGridFx.pending,
    onlyFavoritesTvChannels:
      tvFavoritesEntityModel.$onlyFavoritesTvChannelsGrid,
  },
  ({ onlyFavoritesTvChannelsLoading, onlyFavoritesTvChannels }) =>
    !onlyFavoritesTvChannels && onlyFavoritesTvChannelsLoading
)

export const loadMoreGridFavoritesTvChannels = createEvent()

sample({
  clock: loadMoreGridFavoritesTvChannels,
  filter: not(api.tv.getOnlyFavoritesTvChannelsGridFx.pending),
  fn: () => null,
  target: tvFavoritesEntityModel.loadMoreOnlyFavoritesTvChannelsGrid,
})
